import React from 'react';
import { Link } from 'react-router-dom';
import { Award } from 'lucide-react';
import { createCategorySlug } from '../../utils/urlHelpers';
import {
  formatLeaderValue,
  type CategoryChampion,
  type LeaderMetric,
} from '../../utils/leaderboard';

interface Props {
  champions: CategoryChampion[];
  metric: LeaderMetric;
  darkMode: boolean;
}

const CategoryChampions: React.FC<Props> = ({ champions, metric, darkMode }) => {
  if (champions.length === 0) return null;

  const card = darkMode
    ? 'bg-gray-800/90 border-gray-700 hover:border-indigo-600'
    : 'bg-white border-gray-200 hover:border-indigo-300 shadow-sm';

  return (
    <section className="mb-6 sm:mb-8" aria-labelledby="category-champions-heading">
      <h2
        id="category-champions-heading"
        className={`text-lg font-semibold flex items-center gap-2 mb-3 sm:mb-4 ${
          darkMode ? 'text-white' : 'text-gray-900'
        }`}
      >
        <Award className="text-amber-500 shrink-0" size={22} />
        Kategori şampiyonları
      </h2>
      <p className={`text-sm mb-4 ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
        Her kategoride seçili metriğe göre birinci olan forum — anasayfadaki genel sıralamadan farklı bir
        bakış.
      </p>
      <div className="flex gap-3 overflow-x-auto pb-2 -mx-1 px-1 snap-x snap-mandatory scrollbar-thin">
        {champions.map(({ category, forum, value, growth }) => (
          <article
            key={category}
            className={`snap-start shrink-0 w-[min(100%,260px)] sm:w-[240px] rounded-xl border p-4 transition-colors ${card}`}
          >
            <Link
              to={`/category/${createCategorySlug(category)}`}
              className={`text-xs font-semibold uppercase tracking-wide ${
                darkMode ? 'text-indigo-400 hover:text-indigo-300' : 'text-indigo-600 hover:text-indigo-800'
              }`}
            >
              {category}
            </Link>
            <Link
              to={`/forum/${forum.forum_id}`}
              className={`block mt-2 font-semibold line-clamp-2 hover:underline ${
                darkMode ? 'text-white' : 'text-gray-900'
              }`}
            >
              {forum.name}
            </Link>
            <p className={`mt-2 text-lg font-bold tabular-nums ${darkMode ? 'text-amber-300' : 'text-amber-600'}`}>
              {formatLeaderValue(metric, value, growth)}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default CategoryChampions;
